<template>
  <div class="agent-reviews-view">

    <div v-if="agentReviewsLoaded">
      <info-card class="ut-flex">
        <div>
          <h3 class="ut-mb-2 ut-font-bold">Want more reviews?</h3>
          <div class="md:ut-flex">
            <p class="ut-pb-2">
              Share this link with your customers: <br/> <span class="ut-text-xs">{{ agentReviewLink }}</span>
            </p>
            <div class="md:ut-w-40 md:ut-text-right">
              <span class="btn ut-text-center ut-cursor-pointer ut-text-sm ut-inline-block ut-mt-2"
                    @click.stop.prevent="copyToClipboard">
                    Copy link </span>
              <input type="hidden" id="review-link-to-copy" :value="agentReviewLink">
            </div>
          </div>
        </div>
      </info-card>

      <div v-if="agentReviews.length === 0">You don't have any review yet</div>

      <div v-else class="ut-mb-10">
        <agent-review-card
          v-for="review in agentReviews"
          :key="review.key"
          :review="review"
        />
      </div>
    </div>

    <loading-spinner v-else />
  </div>
</template>

<script>

import { mapState } from 'vuex';
import AgentReviewCard from '@/components/Cards/AgentReviewCard.vue';
import InfoCard from '@/components/Cards/InfoCard.vue';
import LoadingSpinner from '@/components/Animations/LoadingSpinner.vue';

export default {
  name: 'AccountReviews',
  components: {
    AgentReviewCard,
    InfoCard,
    LoadingSpinner,
  },
  data() {
    return {
      agentReviews: [],
      agentReviewsLoaded: false,
    };
  },
  mounted() {
    this.fetchAgentReviews();
  },
  computed: {
    ...mapState({
      agent: state => state.agentStore.agent,
    }),
    agentReviewLink() {
      return `${process.env.VUE_APP_OA_URL}/review-agent/?reid=7&ak=${this.agent.key}`;
    },
  },
  methods: {
    fetchAgentReviews() {
      if (this.agent && this.agent.key) {
        this.$apiServices.oa.review.getAgentReviews(this.agent.key)
          .then((reviews) => {
            this.agentReviews = reviews.sort((a, b) => new Date(`${b.reviewdate} ${b.reviewtime}`) - new Date(`${a.reviewdate} ${a.reviewtime}`));
            this.agentReviewsLoaded = true;
          });
      }
    },
    copyToClipboard() {
      const toCopy = document.querySelector('#review-link-to-copy');
      toCopy.setAttribute('type', 'text');
      toCopy.select();

      try {
        document.execCommand('copy');
      } catch (err) {
        console.log(err);
      }

      /* unselect the range */
      toCopy.setAttribute('type', 'hidden');
      window.getSelection().removeAllRanges();
    },
    // gaEvent(eventAction, eventLabel) {
    //   const label = `AID=${this.agent.id}${eventLabel ? ` | ${eventLabel}` : ''}`;
    //   return {
    //     category: 'AgentPortal',
    //     action: eventAction,
    //     label,
    //   };
    // },
  },
};

</script>

<style lang="scss" scoped>

.table-head{
  border: 1px solid #E3E5E8;
  div {
    @apply ut-text-xs ut-tracking-wide opacity-75;
    opacity: 0.69;
  }
}

  .shadow-box{
      @apply ut-rounded ut-bg-neutral-001 ;
  }

</style>
